import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Carousel, Button } from "react-bootstrap";
import axios from "axios";
import { useSucursal } from '../../contexts/SucursalContext';
import NavbarUni from './componentes/headUni';
import FooterPublic from './FooterPublic';
import ModalAuto from './componentes/ModalAuto';
import { API } from '../../api/URL_API';

function HomePage() {
    const { idSucursal: urlIdSucursal } = useParams();
    const { idSucursal, setIdSucursal } = useSucursal();

    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);

    // ===============================
    // Manejo sucursal
    // ===============================
    useEffect(() => {
        if (urlIdSucursal && urlIdSucursal !== idSucursal) {
            setIdSucursal(urlIdSucursal);
            localStorage.setItem('idSucursal', urlIdSucursal);
        } else if (!idSucursal) {
            const stored = localStorage.getItem('idSucursal');
            if (stored) setIdSucursal(stored);
        }
    }, [urlIdSucursal, idSucursal, setIdSucursal]);

    // ===============================
    // Obtener banners
    // ===============================
    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const response = await axios.get(
                    `${API}/api/banners`
                );
                //console.log("🎠 Banners Home:", response.data);
                setBanners(response.data);
            } catch (error) {
                console.error("❌ Error cargando banners:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBanners();
    }, []);

    return (
        <div className="bg-light" style={{ paddingTop: '80px' }}>
            <ModalAuto />
            <NavbarUni />

            {/* ===============================
                BANNER HOME
            =============================== */}
            <section className="banner-wrapper">
                {loading ? (
                    <div className="banner-skeleton">
                        <div className="banner-skeleton-img" />
                    </div>
                ) : banners.length === 0 ? (
                    <div className="text-center py-5 text-muted">
                        No hay banners disponibles
                    </div>
                ) : (
                    <Carousel fade controls indicators interval={5000} pause={false}>
                        {banners.map((banner, index) => (
                            <Carousel.Item key={banner.idBanner}>
                                <Link to={`/${idSucursal}/Productos/${banner.link}`}>
                                    <div className="banner-frame">
                                        <div
                                            className="banner-bg"
                                            style={{ backgroundImage: `url(${banner.imageUrl})` }}
                                        />

                                        <img
                                            className="banner-img"
                                            src={banner.imageUrl}
                                            alt="Banner"
                                            loading={index === 0 ? "eager" : "lazy"}
                                        />

                                        {/* 🔥 CTA OVERLAY */}
                                        <div className="banner-overlay">
                                            <div className="banner-cta">
                                                <span className="banner-cta-text">
                                                    Descubrir colección
                                                </span>
                                                <span className="banner-cta-btn">
                                                    Ver productos →
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                )}
            </section>

            {/* 🔽 BOTÓN FUERA DEL BANNER */}
            <div className="banner-action-wrapper">
                <Button
                    as={Link}
                    to={`/${idSucursal}/Catalogo`}
                    size="lg"
                    variant='danger'
                    className="banner-action-btn"
                >
                    <svg
                        className='icon-bounce me-2 '
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 64 64"
                        fill="none"
                        stroke="#FFFFFF"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                    >
                        <path d="M10 42c7-5 18-10 30-10 8 0 16 3 22 6v5c-5 2-12 4-20 4-6 0-10-1-14-3-5-3-9-6-15-7-3-1-5 1-7 2z" />
                        <path d="M6 42c0-10 3-24 18-29 12-4 22 4 26 19" />
                    </svg>
                    Mira Catálogo completo
                </Button>
            </div>

            <FooterPublic idSucursal={idSucursal} />
        </div>
    );
}

export default HomePage;
